export default "__VITE_ASSET__DLXQ1t8w__"